import { setOpenAIConsentState } from './identity';
import { enqueueOaiq } from './sdk';

export const grantOpenAIPixelConsent = () => {
  enqueueOaiq('consent', true);
  setOpenAIConsentState(true);
};
export const revokeOpenAIPixelConsent = () => {
  enqueueOaiq('consent', false);
  setOpenAIConsentState(false);
};
